import axios from 'axios';

// Idee per la parola chiave (backend features/keywordideas): dalla fonte attiva in Impostazioni > Seo,
// Google Keyword Planner (googleads) oppure DataForSEO; se ne attiva uno solo alla volta.
// `attivo` vale un minuto: il pannello SEO e' montato una volta per lingua, ma cambiando profilo
// ("Loggati come") o accendendo un servizio il valore deve aggiornarsi presto.
const ATTIVO_MS = 60 * 1000;
const FONTI = ['googleads', 'dataforseo'];

const state = {
	attivo: null,
	letto: 0,
};

const getters = {
	getAttivo: state => state.attivo,
};

const actions = {
	// true se almeno una fonte delle idee e' accesa
	verificaAttivo: async context => {
		if (context.state.attivo !== null && Date.now() - context.state.letto < ATTIVO_MS) return context.state.attivo;
		const servizi = await context.dispatch('services/getServiceFetchActive', FONTI, { root: true });
		const attivo = Array.isArray(servizi) && servizi.some(s => FONTI.includes(s.service) && s.active);
		context.commit('setAttivo', attivo);
		return attivo;
	},

	// payload: { keyword, lang }. Ritorna { data: { fonte, items, location, cached } } oppure { error, detail? }
	cerca: async (context, payload) => {
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}keywordideas`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => res.data)
			.catch(err => {
				const data = (err.response && err.response.data) || {};
				return { error: data.message || err.message || 'keywordideas_error', detail: data.detail };
			});
	},
};

const mutations = {
	setAttivo: (state, value) => {
		state.attivo = value;
		state.letto = Date.now();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
